import React, { useState } from "react";
import { SCHEDULE_TYPES, type SchedulerRunnerData } from "../SchedulerUtils";
import DayOfMonthSelection from "./DayOfMonthSelection";
import SchedulerTimes from "./SchedulerTimes";
import HourSelection, { type HourSelectionProps } from "./HourSelection";

interface MonthlyRunnerData {
  selectedDays?: number[];
  times?: string[];
}

interface MonthlyRunnerProps {
  disabled?: boolean;
  data?: MonthlyRunnerData;
  onChange: (runnerData: SchedulerRunnerData) => void;
  HourSelectionComponent?: React.ComponentType<HourSelectionProps>;
}

const MonthlyRunner: React.FC<MonthlyRunnerProps> = ({
  disabled = false,
  data,
  onChange,
  HourSelectionComponent = HourSelection,
}) => {
  const [selectedDays, setSelectedDays] = useState<number[]>(
    data?.selectedDays || []
  );
  const [times, setTimes] = useState<string[]>(data?.times || ["00:00"]);

  const onTimesChange = (times: string[]) => {
    setTimes(times);
    onChange({
      type: SCHEDULE_TYPES.MONTH,
      data: {
        times,
        selectedDays,
      },
    });
  };

  const onSelectedDaysChange = (selectedDays: number[]) => {
    setSelectedDays(selectedDays);
    onChange({
      type: SCHEDULE_TYPES.MONTH,
      data: {
        times: data?.times || ["00:00"],
        selectedDays,
      },
    });
  };

  return (
    <div className="monthly-runner-container">
      <DayOfMonthSelection
        selectedDays={selectedDays}
        onChange={onSelectedDaysChange}
        multi={true}
        disabled={disabled}
      />
      <div className="times-container">
        <SchedulerTimes
          maxTimeSlots={1}
          initialTimes={times}
          onChange={onTimesChange}
          HourSelectionComponent={HourSelectionComponent}
          label="Select Time (UTC)"
          data-testid={"scheduler-monthly"}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default MonthlyRunner;
